import { RootState, useAppSelector } from '../../store.model';
import { getZipControlUnitsByDeviceIds } from '../selectors';
import _, { isEqual } from 'lodash';
import useDevicesByParams from '../../commander/hooks/useDevicesByParams';
import ControlUnitAPI from '../api/ControlUnitAPI';
import useMultipleQueries from '../../../util/rtk/useQueries';
import { orComparator } from '../../../util/lodash/orComparator';

/**
 * Get and fetch control unit from specified device
 * @param deviceId
 * @returns [controlUnits, loading, error]
 * 
 * @usage
´´´ts
const {
    data: devicesControlUnits,
    isLoading: devicesControlUnitsLoading,
    error: devicesControlUnitsError,
  } = useControlUnitsByIds(onError, { deviceIds: ['device1', 'device2'] });
´´´
 */
export function useControlUnitsByIds(options?: {
  deviceIds?: string[];
  hideCommander?: boolean;
}) {
  const {
    devicesIds,
    data: _devices,
    ...restDevices
  } = useDevicesByParams(options);
  const { data, ...restResponseControlUnits } = useMultipleQueries(
    ControlUnitAPI.endpoints.getControlUnitById,
    devicesIds,
    {
      skip: !devicesIds?.length,
    }
  );
  const devicesControlUnits = useAppSelector(
    (state: RootState) =>
      getZipControlUnitsByDeviceIds(state, {
        devicesIds,
        hideCommander: options?.hideCommander,
      }),
    isEqual
  );

  return _.chain({
    data: devicesControlUnits,
    ...restResponseControlUnits,
  })
    .mergeWith(restDevices, orComparator)
    .value();
}
